import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

import { ExportType } from '@enums/export-type.enum';
import { SimulationInfo } from '@classes/simulation/simulation-info';
import { SimulationService } from '@services/simulation.service';
import { ReportService } from '@services/report.service';

@Component({
    selector: 'app-report-export-crac',
    templateUrl: './report-export-crac.component.html',
    styleUrls: ['./report-export-crac.component.scss']
})
export class ReportExportCracComponent implements OnInit {
    @Input() exportType: ExportType;

    simulations: SimulationInfo[];
    years: number[];
    selectForm: FormGroup;
    isLoading: boolean;

    constructor(
        private simuSrv: SimulationService,
        private fb: FormBuilder,
        private reportSrv: ReportService
    ) {
    }

    ngOnInit() {
        this.initSubscriptions();
    }

    getReport() {
        this.isLoading = true;

        if (this.selectForm.value.simulation !== '' && this.selectForm.value.simulation != null) {
            this.reportSrv.generateXlsFromCode(this.selectForm.value.simulation, this.exportType, this.selectForm.value.year)
                .subscribe(() => {
                    this.isLoading = false;
                }, () => {
                    this.isLoading = false;
                });
        }
    }

    private initSubscriptions(): void {
        this.simuSrv.getInfoList()
            .subscribe(simulationsList => {
                this.simulations = simulationsList;

                this.reportSrv.getCracYears()
                .subscribe(reportData => {
                    this.years = reportData.years;
                    this.initForm();
                });
            });
    }

    private initForm(): void {
        this.selectForm = this.fb.group({
            simulation: ['', Validators.required],
            year: ['', Validators.required]
        });

        if (this.years && this.years[0]) {
            var year = this.years[this.years.length - 1];
            this.selectForm.controls['year'].setValue(year);
        }
    }
}
